module.exports = __webpack_public_path__ + "static/img/b.4c623b8a.png";